import api from 'Application/api/api';

const getDistanceProcedureFileRejectReasons = (cancelToken = null) =>
    api.get(
        '/measures/vehicles/driver-licenses/distance-procedure-file-reject-reasons',
        { cancelToken },
    );

export default getDistanceProcedureFileRejectReasons;
